import { MSCartIcon } from '@wolfejs/icons/IconMap';
import type { ButtonProps } from '@wolfejs/ui/Button/Button';
import { Button } from '@wolfejs/ui/Button/Button';
import { UIVariantsExtra } from '@wolfejs/ui/types/UI';
import { cn } from '@wolfejs/ui/utils/classnames';

export type CartButtonProps = ButtonProps & {
  itemCount?: number;
};

const CartButton = ({ className, itemCount, ...otherProps }: CartButtonProps) => {
  return (
    <Button
      className={cn('bg-default-100 border-none', className)}
      variant={UIVariantsExtra.alternative}
      shape="circle"
      {...otherProps}
    >
      <MSCartIcon />
      {Boolean(itemCount) && (
        <span
          className={cn(
            'bg-error absolute -right-1 -top-1 flex h-6 w-6 items-center justify-center rounded-full text-white',
            { 'text-xs': itemCount && itemCount > 9 }
          )}
        >
          {itemCount}
        </span>
      )}
    </Button>
  );
};

export default CartButton;
